import { Card, CardHeader, Divider, Typography, useMediaQuery } from '@mui/material';
import type { Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PropertyList } from '../../../../components/atoms/property-list';
import { PropertyListItem } from '../../../../components/atoms/property-list-item';

import { DiscountTemplate } from '@/features/hosts/api/types/discount';

interface Props {
  discountTemplates: DiscountTemplate[];
}

export const DiscountInfo = ({ discountTemplates }: Props) => {
  const { t } = useTranslation(['host']);

  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const align = mdDown ? 'vertical' : 'horizontal';

  return (
    <Card variant="outlined">
      <CardHeader title={t('host:discount.cardTitle')} />
      <Divider />
      <PropertyList>
        {discountTemplates.length > 0 ? (
          discountTemplates.map((discountTemplate, i) => (
            <PropertyListItem
              key={discountTemplate.id}
              align={align}
              label={`${t('host:discount.discount')}: ${i + 1}`}
              value={discountTemplate.name}
            />
          ))
        ) : (
          <Typography sx={{ p: 2, px: 3 }}>{t('host:discount.thereIsNoDiscounts')}</Typography>
        )}
      </PropertyList>
    </Card>
  );
};
